"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("react-utils/debounce"));

var _I18n = _interopRequireDefault(require("I18n"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIFieldset = _interopRequireDefault(require("UIComponents/form/UIFieldset"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _popover = require("../../constants/popover");

var _link = require("../../constants/link");

var _url = require("../../utils/url");

var _link2 = require("../../utils/link");

var _LinkFields = _interopRequireDefault(require("./LinkFields"));

var CancelButton = (0, _styledComponents.default)(_UIButton.default).withConfig({
  displayName: "LinkPopoverControls__CancelButton",
  componentId: "iew71t-0"
})(["color:", " !important;"], _colors.OBSIDIAN);
/**
 * @TODO Remove this once `useContextualToolbar` is fully ungated
 */

var LinkPopoverControls = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LinkPopoverControls, _Component);

  function LinkPopoverControls(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LinkPopoverControls);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LinkPopoverControls).call(this, props));

    _this.validateLinkInput = function (href) {
      var linkType = _this.props.linkType;
      return (0, _link2.validateLink)(linkType, href);
    };

    _this.canSubmit = function () {
      var _this$props = _this.props,
          href = _this$props.href,
          linkText = _this$props.linkText;
      return !((0, _url.isWhitespace)(href) || (0, _url.isWhitespace)(linkText));
    };

    _this.handleSubmit = function () {
      var hasSubmitted = _this.state.hasSubmitted;
      var _this$props2 = _this.props,
          onSubmit = _this$props2.onSubmit,
          isValidLink = _this$props2.isValidLink,
          href = _this$props2.href;
      var newIsValidLink = isValidLink;

      if (!hasSubmitted) {
        newIsValidLink = _this.validateLinkInput(href);
      }

      if (hasSubmitted || newIsValidLink) {
        onSubmit();
        return;
      }

      _this.props.onUpdate({
        isValidLink: newIsValidLink
      });

      _this.setState({
        hasSubmitted: true
      });
    };

    _this.handleUrlKeyDown = function (evt) {
      if (evt.key === _popover.KeyTypes.ENTER) {
        _this.handleSubmit();

        evt.preventDefault();
      }
    };

    _this.handleLinkTextChange = function (_ref) {
      var value = _ref.target.value;

      _this.props.onUpdate({
        linkText: value
      });
    };

    _this.handleLinkTypeChange = function (linkType) {
      _this.setState({
        hasSubmitted: false
      });

      _this.props.onLinkTypeChange(linkType);
    };

    _this.handleValidationUpdate = (0, _debounce.default)(function (href) {
      _this.props.onUpdate({
        isValidLink: _this.validateLinkInput(href)
      });
    }, 300);

    _this.handleUpdate = function (linkInfo) {
      var href = linkInfo.href;
      var hasSubmitted = _this.state.hasSubmitted;

      if (href && hasSubmitted) {
        _this.handleValidationUpdate(href);
      }

      _this.props.onUpdate(linkInfo);
    };

    _this.state = {
      hasSubmitted: false
    };
    return _this;
  }

  (0, _createClass2.default)(LinkPopoverControls, [{
    key: "renderLinkTextInput",
    value: function renderLinkTextInput() {
      var _this$props3 = this.props,
          linkText = _this$props3.linkText,
          canModifyLinkText = _this$props3.canModifyLinkText;
      if (!canModifyLinkText) return null;
      return _react.default.createElement(_UIFormControl.default, {
        className: "m-bottom-1",
        label: _I18n.default.text((0, _link.i18nKey)("linkText.label"))
      }, _react.default.createElement(_UITextInput.default, {
        autoFocus: canModifyLinkText,
        "data-test-id": "link-text-input",
        value: linkText,
        onChange: this.handleLinkTextChange
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          onClose = _this$props4.onClose,
          externalLink = _this$props4.externalLink,
          noFollow = _this$props4.noFollow,
          href = _this$props4.href,
          fetchPages = _this$props4.fetchPages,
          fetchMeetingsByUsers = _this$props4.fetchMeetingsByUsers,
          fetchAnchors = _this$props4.fetchAnchors,
          linkType = _this$props4.linkType,
          onSelectFile = _this$props4.onSelectFile,
          currentFileMeta = _this$props4.currentFileMeta,
          showRefAndTargetControls = _this$props4.showRefAndTargetControls,
          useEmailSubscription = _this$props4.useEmailSubscription,
          allowFileDownload = _this$props4.allowFileDownload,
          allowMeetingLink = _this$props4.allowMeetingLink,
          emailSubscriptionLinkTypes = _this$props4.emailSubscriptionLinkTypes,
          allowAnchorLinks = _this$props4.allowAnchorLinks,
          allowPageLinks = _this$props4.allowPageLinks,
          dropdownClassName = _this$props4.dropdownClassName,
          canModifyLinkText = _this$props4.canModifyLinkText,
          scopes = _this$props4.scopes,
          userId = _this$props4.userId,
          popoverType = _this$props4.popoverType,
          useExplicitSave = _this$props4.useExplicitSave,
          isValidLink = _this$props4.isValidLink;
      return _react.default.createElement(_UIFieldset.default, {
        className: "small-popover-body m-y-3 m-x-2",
        _size: "small"
      }, _react.default.createElement("h4", {
        className: "m-bottom-2"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _link.i18nKey)(popoverType + "Title")
      })), this.renderLinkTextInput(), _react.default.createElement(_LinkFields.default, {
        dropdownClassName: dropdownClassName,
        externalLink: externalLink,
        noFollow: noFollow,
        href: href,
        onUpdate: this.handleUpdate,
        onLinkTypeChange: this.handleLinkTypeChange,
        fetchPages: fetchPages,
        fetchMeetingsByUsers: fetchMeetingsByUsers,
        fetchAnchors: fetchAnchors,
        linkType: linkType,
        onSelectFile: onSelectFile,
        onUrlKeyDown: this.handleUrlKeyDown,
        showRefAndTargetControls: showRefAndTargetControls,
        currentFileMeta: currentFileMeta,
        useEmailSubscription: useEmailSubscription,
        allowFileDownload: allowFileDownload,
        allowMeetingLink: allowMeetingLink,
        emailSubscriptionLinkTypes: emailSubscriptionLinkTypes,
        allowAnchorLinks: allowAnchorLinks,
        allowPageLinks: allowPageLinks,
        shouldAutoFocus: !canModifyLinkText,
        scopes: scopes,
        userId: userId,
        isValidLink: isValidLink
      }), useExplicitSave && _react.default.createElement("div", {
        className: showRefAndTargetControls ? 'm-top-3' : 'm-top-6'
      }, _react.default.createElement(_UIButton.default, {
        use: "tertiary",
        "data-test-id": "submit-link-confirm-button",
        onClick: this.handleSubmit,
        disabled: !this.canSubmit(),
        size: "small"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _link.i18nKey)(popoverType + "Submit")
      })), _react.default.createElement(CancelButton, {
        use: "tertiary-light",
        onClick: onClose,
        size: "small"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _link.i18nKey)('cancel')
      }))));
    }
  }]);
  return LinkPopoverControls;
}(_react.Component);

exports.default = LinkPopoverControls;
LinkPopoverControls.propTypes = {
  externalLink: _propTypes.default.bool.isRequired,
  noFollow: _propTypes.default.bool.isRequired,
  linkText: _propTypes.default.string.isRequired,
  canModifyLinkText: _propTypes.default.bool,
  href: _propTypes.default.string.isRequired,
  onUpdate: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  onLinkTypeChange: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func.isRequired,
  fetchPages: _propTypes.default.func.isRequired,
  fetchMeetingsByUsers: _propTypes.default.func.isRequired,
  fetchAnchors: _propTypes.default.func.isRequired,
  linkType: _propTypes.default.oneOf(Object.values(_link.LinkTypes)).isRequired,
  onSelectFile: _propTypes.default.func.isRequired,
  showRefAndTargetControls: _propTypes.default.bool.isRequired,
  currentFileMeta: _propTypes.default.object,
  dropdownClassName: _propTypes.default.string,
  useEmailSubscription: _propTypes.default.bool,
  allowFileDownload: _propTypes.default.bool,
  allowMeetingLink: _propTypes.default.bool,
  emailSubscriptionLinkTypes: _propTypes.default.array,
  allowAnchorLinks: _propTypes.default.bool,
  allowPageLinks: _propTypes.default.bool,
  scopes: _propTypes.default.array,
  userId: _propTypes.default.number,
  popoverType: _propTypes.default.oneOf(Object.values(_popover.PopoverType)),
  useExplicitSave: _propTypes.default.bool,
  isValidLink: _propTypes.default.bool
};
LinkPopoverControls.defaultProps = {
  canModifyLinkText: false,
  linkText: '',
  popoverType: _popover.PopoverType.INSERT
};
module.exports = exports.default;